import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCTC5sufRBYcoFWeED94qRSPQv7ZDJ3XrI",
  authDomain: "malaika-d6f4a.firebaseapp.com",
  projectId: "malaika-d6f4a",
  storageBucket: "malaika-d6f4a.firebasestorage.app",
  messagingSenderId: "442163783571",
  appId: "1:442163783571:web:85ceda32cf11a645f1aa66",
  measurementId: "G-NPW42G368H"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;